import { initialState } from "./constants";
export default {
	reservationModel: initialState()
};
